import { lbApiBeta } from '@/utils/axiosConfig';
import { REBOOST_OFFER_WINDOW_HOURS } from '@/utils/constants/boost';

const HOUR = 3600e3;

// The instant the boost ends (ms), from the timestamp the backend sends
// as activeUntil (/api/boost-summary) or endDate (the ad's
// extraVisibility). The boost runs until exactly that time — nothing here
// stretches it to the end of the day. Null when there is no readable date.
export function boostEndTime(activeUntil) {
  if (!activeUntil) return null;
  const end = new Date(activeUntil).getTime();
  return Number.isFinite(end) ? end : null;
}

// When the re-boost offer closes: REBOOST_OFFER_WINDOW_HOURS after the
// end. Null when the end is unknown.
export function reboostOfferClosesAt(activeUntil) {
  const end = boostEndTime(activeUntil);
  return end === null ? null : end + REBOOST_OFFER_WINDOW_HOURS * HOUR;
}

// Consumables A/B: when the ad's re-boost window closes, read from
// /api/boost-summary. Null means "no window": a running boost, no end date
// or a failed read. While it is open the Boost button shows the pulsing
// icon and reopens the result panel instead of the purchase modal (the
// extraVisibility store keeps the answer for both).
//
// activeUntil alone says whether the boost has ended: the backend keeps
// isActive (like the ad's extraVisibility) for a while after the end.
export async function fetchReboostClosesAt(propositionId) {
  try {
    const { data } = await lbApiBeta.get(
      `/api/boost-summary?propositionId=${propositionId}`
    );
    const end = boostEndTime(data?.activeUntil);
    if (end === null || end > Date.now()) return null;
    return end + REBOOST_OFFER_WINDOW_HOURS * HOUR;
  } catch (e) {
    return null;
  }
}

// True for REBOOST_OFFER_WINDOW_HOURS after the ad's boost ended — for
// callers outside the Boost button (the swap list's floating CTA).
export async function boostEndedRecently(propositionId, now = Date.now()) {
  const closesAt = await fetchReboostClosesAt(propositionId);
  return closesAt !== null && closesAt > now;
}
